import React, { useState, useEffect, useRef, useCallback } from 'react';
import style from './MyDataCollect.module.css';
import HeadSub from '../../../../components/comm/HeadSub';
import { useLocation, useNavigate } from "react-router-dom";
import CircularProgress from '@mui/material/CircularProgress';
import imgLastLoading from '../../../../images/common/img_my_data_last_loading.svg';
import axiosApi from '../../../../api/daonAxios';
import CODE from '../../../../constants/code';
import URL from "../../../../constants/url";
import Modal from "../../../../components/comm/Modal"

import ToastPopup from '../../../../components/comm/ToastPopup';

const MyDataCollect = () => {

    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    const location = useLocation();
    const id = location.state?.id;

    const user = JSON.parse(sessionStorage.getItem("loginUser"));

    const navigate = useNavigate();

    const [mediHlthInfo, setMediHlthInfo] = useState({id : id, usrInfoId : user.usrInfoId, frstInptAt: '1', bdpRh: 'RH+'});

    const [isNextBtnDisabled, setIsNextBtnDisabled] = useState(true);

    const [step, setStep] = useState(1);

    const [cancelDataCollect, setCancelDataCollect] = useState(false);  //그만하기 컨펌펌
    const [saveCompleteOpen, setSaveCompleteOpen] = useState(false);  //저장완료 모달

    // 1) 표시용 상태 추가
    const [heightRaw, setHeightRaw] = useState('');
    const [bdwghRaw, setBdwghRaw] = useState('');

    /////////////////이전 다음 핸들링
    const myDataLength = 4;

    // 뒤로 가기(popstate) 핸들링
    useEffect(() => {
        const handlePopState = () => {
            if (step === 'last') {
                if(user.gendr === '1') {
                    setStep(myDataLength - 1)
                } else {
                    setStep(myDataLength); // 마지막에서 뒤로가면 마지막 입력 스텝으로
                }
            } else if (step > 1) {
                setStep(prev => prev - 1);
            } else {
                navigate('/HomeCareMain', { replace: true });
            }
        };

        window.addEventListener('popstate', handlePopState);
        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [step, navigate]);

    // i가 변경될 때 히스토리 쌓기 (마지막은 제외)
    useEffect(() => {
        if (step !== 'last') {
            window.history.pushState({ step: step }, '');
        } else {
            //마지막일때 저장
            saveMediHlthInfo();
        }
    }, [step]);

    // const onClickNext = () => {
    //     console.log(mediHlthInfo)
    //     if (step < myDataLength) {
    //         setStep(prev => prev + 1);
    //     } else if (step === myDataLength) {
    //         setStep('last');
    //     }
    // };

    const onClickNext = () => {
        if (step === 1) {
            commitDecimal('height', heightRaw);
            commitDecimal('bdwgh', bdwghRaw);
        }
        if (step < myDataLength) {
            if(step !== 3) {
                setStep(prev => prev + 1)
            } else {
                if(user.gendr !== '1') {
                    setStep(prev => prev + 1)
                } else {
                    setStep('last')
                }
            }
        }
        else if (step === myDataLength) setStep('last');
    };

    const onClickPrev = () => {
        if (step === 'last') {

            setStep(myDataLength);
        } else if (step > 1) {
            setStep(prev => prev - 1);
        } else {
            navigate(-1);
        }
    };

    const handleBackClick = () => {
        setCancelDataCollect(true)
    }

    const handleChangeNumber = (target) => {
        const { name, value } = target;
        const regex = /^\d{0,3}(\.\d{0,3})?$/;

        if (value === '' || regex.test(value)) {
            setMediHlthInfo((prev) => ({ ...prev, [name]: value }));
        }
    }

    const handleChangeRadio = (target) => {
        const { name, value } = target;
        setMediHlthInfo((prev) => ({ ...prev, [name]: value }));
    };

    useEffect(() => {
        if (step === 1) {
            setIsNextBtnDisabled(!(isValidDecimal(heightRaw) && isValidDecimal(bdwghRaw)));
        } else if (step === 2) {
            const { bdpAbo, bdpRh } = mediHlthInfo;
            setIsNextBtnDisabled(!(bdpAbo && bdpRh));
        } else if (step === 3) {
            setIsNextBtnDisabled(!mediHlthInfo.inorgCntrAt);
        } else if (step === 4) {
            setIsNextBtnDisabled(!mediHlthInfo.prgncPsblAt);
        } else {
            setIsNextBtnDisabled(true);
        }
    }, [step, heightRaw, bdwghRaw, mediHlthInfo]);

    //여기 화면에 도착만 해도 최초등록 한것으로 간주하기 위해 업데이트xxxx -> 기획상 다시 들어가도록 되어 있음음
    // useEffect(() => {
    //     saveMediHlthInfo();
    // },[])

    const saveMediHlthInfo = useCallback(async () => {

        const url = "/mypage/saveMediHlthInfo";

        const jToken = localStorage.getItem('jToken');

        const reqOptions = {
            headers: {
                Authorization: jToken,
            },
        }

        const startTime = Date.now();

        await axiosApi.post(url, mediHlthInfo, reqOptions)
        // await axiosApi.post(url, mediHlthInfo)
        .then((res) => {
            if (res.data.resultCode === CODE.RCV_SUCCESS) {

                const elapsed = Date.now() - startTime;

                if (elapsed >= 2000) {
                    // 2초 이상 지났으면 바로 보여줌
                    setSaveCompleteOpen(true);
                } else {
                    // 2초보다 빠르면 남은 시간만큼 대기 후 보여줌
                    setTimeout(() => {
                        setSaveCompleteOpen(true);
                    }, 2000 - elapsed);
                }

            } else {
                setToastMessage(res.data.resultMessage);
                setToast(true);
            }
        })
        .catch(err => {
            console.error("내 의료정보 저장 중 오류 : ", err);
        })

    },[mediHlthInfo])

    const handleClickSaveCompleteBtn = () => {
        setSaveCompleteOpen(false);
        navigate('/MyPageMain', { replace: true });
    }

    const handleClickCancelBtn = (type) => {
        if(type === 'no') {
            setCancelDataCollect(false);
        } else {
            navigate('/HomeCareMain', { replace: true });
        }
    }

    // 2) 부분 입력 허용 패턴 (999.999까지, 마지막 점 허용)
    // const PARTIAL_DECIMAL = /^(\d{0,3}(\.\d{0,3})?|\d{0,3}\.)$/;
    // 2) 부분 입력 허용 패턴 (999.9까지, 마지막 점 허용)
    const PARTIAL_DECIMAL = /^(\d{0,3}(\.\d{0,1})?|\d{0,3}\.)$/;

    // 3) onChange: raw만 업데이트 (콤마를 점으로 통일)
    const handleChangeDecimal = (e) => {
        const { name, value } = e.target;
        let v = value.replace(',', '.');

        // const n = parseFloat(v);
        // if (!isNaN(n) && n > 999.9) v = '999.9';
        if (v === '' || PARTIAL_DECIMAL.test(v)) {
            if (name === 'height') setHeightRaw(v);
            if (name === 'bdwgh') setBdwghRaw(v);
        }
    };

    // 4) 확정 로직: 소수 3자리, 최대 999.999로 정규화
    const commitDecimal = (name, raw) => {
        if (!raw || raw === '.' ) return; // 빈 값/단독 점은 확정 X
        const [i, f = ''] = raw.split('.');
        const intPart = (i || '').slice(0, 3);
        // const fracPart = f.slice(0, 3);
        const fracPart = f.slice(0, 1);
        const normalized = fracPart ? `${intPart}.${fracPart}` : intPart;
        // const num = Math.min(999.999, parseFloat(normalized));
        const num = Math.min(999.9, parseFloat(normalized));
        if (!isNaN(num)) {
            setMediHlthInfo(prev => ({ ...prev, [name]: num.toString() }));
        }
    };

    const isValidDecimal = (v) => /^\d{1,3}(\.\d{1,3})?$/.test(v) && parseFloat(v) <= 999.9;

    return (
        <>
            <div className={"header header-sub "} >
                <div className='left' onClick={handleBackClick}>
                    <button> <span className='blind'>뒤로가기</span> </button>
                    <h3>내 의료 정보 모으기</h3>
                </div>
            </div>

            <div id="sub-content" data-layout="white">
                <div className="inner-wrap">
                    {/* 정보 입력 화면 */}
                    {step !== 'last' && (
                        <div className={style['my-data-enter-inform']}>
                            <div className={style['top-txt']}>
                                <p>거의 다 왔어요! <br />
                                    마지막으로 몇 가지 질문에 답해주세요.
                                </p>
                                {step === 1 && (<strong>현재 키와 몸무게를 알려주세요!</strong>)}
                                {step === 2 && (<strong>혈액형을 알려주세요!</strong>)}
                                {step === 3 && (<strong>이전에 장기 기증을 <br />신청한 적이 있으신가요?</strong>)}
                                {step === 4 && (<strong>현재 임신 가능성이 있으신가요?</strong>)}
                            </div>

                            {/* 이하 질문별 UI 생략 — 기존 그대로 유지 */}

                            {/* 키 / 몸무게 입력  */}
                            {step === 1 ? (
                                <div className={style['mid-txt']}>
                                <div className={style['input-txt']}>
                                    <p>키</p>
                                    <div className='input-box' data-type='c' data-text-align="left">
                                        {/* <input type="number" name="height" id="pill-name" placeholder='---' value={mediHlthInfo.height ?? ''} onChange={(e) => handleChangeNumber(e.target)}/> */}
                                        <input
                                            type="text"
                                            inputMode="decimal"
                                            name="height"
                                            placeholder="---"
                                            value={heightRaw}
                                            onChange={handleChangeDecimal}
                                            onBlur={() => commitDecimal('height', heightRaw)}
                                        />
                                        <span className='unit'>cm</span>
                                    </div>
                                </div>
                                <div className={style['input-txt']}>
                                    <p>체중</p>
                                    <div className='input-box' data-type='c'  data-text-align="left">
                                        {/* <input type="number" name="bdwgh" id="pill-name" placeholder='---' value={mediHlthInfo.bdwgh ?? ''} onChange={(e) => handleChangeNumber(e.target)}/> */}
                                        <input
                                            type="text"
                                            inputMode="decimal"
                                            name="bdwgh"
                                            placeholder="---"
                                            value={bdwghRaw}
                                            onChange={handleChangeDecimal}
                                            onBlur={() => commitDecimal('bdwgh', bdwghRaw)}
                                        />
                                        <span className='unit'>kg</span>
                                    </div>
                                </div>
                                </div>
                            ) : null}


                            {/* 혈액형 선택  */}
                            {step === 2 ? (
                                <div className={style['mid-txt']}>
                                    <div className={style['select-lists-box']}>
                                        <p>ABO</p>
                                        <ul data-layout="2x2">
                                            <li>
                                                <div className='radio-selectbox'>
                                                    <input type="radio" id="bloodType-select1" name='bdpAbo' value={'A'} checked={mediHlthInfo.bdpAbo === 'A'} onChange={(e) => handleChangeRadio(e.target)}/>
                                                    <label htmlFor="bloodType-select1">
                                                        <span>A</span>
                                                    </label>
                                                </div>
                                            </li>
                                            <li>
                                                <div className='radio-selectbox'>
                                                    <input type="radio" id="bloodType-select2" name='bdpAbo' value={'B'} checked={mediHlthInfo.bdpAbo === 'B'} onChange={(e) => handleChangeRadio(e.target)}/>
                                                    <label htmlFor="bloodType-select2">
                                                        <span>B</span>
                                                    </label>
                                                </div>
                                            </li>
                                            <li>
                                                <div className='radio-selectbox'>
                                                    <input type="radio" id="bloodType-select3" name='bdpAbo' value={'O'} checked={mediHlthInfo.bdpAbo === 'O'} onChange={(e) => handleChangeRadio(e.target)}/>
                                                    <label htmlFor="bloodType-select3">
                                                        <span>O</span>
                                                    </label>
                                                </div>
                                            </li>
                                            <li>
                                                <div className='radio-selectbox'>
                                                    <input type="radio" id="bloodType-select4" name='bdpAbo' value={'AB'} checked={mediHlthInfo.bdpAbo === 'AB'} onChange={(e) => handleChangeRadio(e.target)}/>
                                                    <label htmlFor="bloodType-select4">
                                                        <span>AB</span>
                                                    </label>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>

                                    <div className={style['select-lists-box']}>
                                        <p>RH</p>
                                        <ul data-layout="2x2">
                                            <li>
                                                <div className='radio-selectbox'>
                                                    <input type="radio" id="rh-select1" name='bdpRh' value={'RH+'} checked={mediHlthInfo.bdpRh === 'RH+'} onChange={(e) => handleChangeRadio(e.target)}/>
                                                    <label htmlFor="rh-select1">
                                                        <span>RH+</span>
                                                    </label>
                                                </div>
                                            </li>
                                            <li>
                                                <div className='radio-selectbox'>
                                                    <input type="radio" id="rh-select2" name='bdpRh' value={'RH-'} checked={mediHlthInfo.bdpRh === 'RH-'} onChange={(e) => handleChangeRadio(e.target)}/>
                                                    <label htmlFor="rh-select2">
                                                        <span>RH-</span>
                                                    </label>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            ) : null}


                            {/* 장기 기증 선택  */}

                            {step === 3 ? (
                                <div className={style['mid-txt']}>
                                    <div className={style['select-lists-box']}>
                                        <ul>
                                            <li>
                                                <div className='radio-selectbox'>
                                                    {/* <input type="radio" id="donation-select1" name='donation-select'/> */}
                                                    <input type="radio" id="donation-select1" name='inorgCntrAt' value={'1'} checked={mediHlthInfo.inorgCntrAt === '1'} onChange={(e) => handleChangeRadio(e.target)}/>
                                                    <label htmlFor="donation-select1">
                                                        <span>있음</span>
                                                    </label>
                                                </div>
                                            </li>
                                            <li>
                                                <div className='radio-selectbox'>
                                                    <input type="radio" id="donation-select2" name='inorgCntrAt' value={'0'} checked={mediHlthInfo.inorgCntrAt === '0'} onChange={(e) => handleChangeRadio(e.target)}/>
                                                    <label htmlFor="donation-select2">
                                                        <span>없음</span>
                                                    </label>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            ) : null}



                            {/* 임신 가능성 선택  */}
                            {step === 4 ? (
                                <div className={style['mid-txt']}>
                                    <div className={style['select-lists-box']}>
                                        <ul>
                                            <li>
                                                <div className='radio-selectbox'>
                                                    {/* <input type="radio" id="pregnancy-select1" name='pregnancy-select'/> */}
                                                    <input type="radio" id="pregnancy-select1" name='prgncPsblAt' value={'1'} checked={mediHlthInfo.prgncPsblAt === '1'} onChange={(e) => handleChangeRadio(e.target)}/>
                                                    <label htmlFor="pregnancy-select1">
                                                        <span>있음</span>
                                                    </label>
                                                </div>
                                            </li>
                                            <li>
                                                <div className='radio-selectbox'>
                                                    {/* <input type="radio" id="pregnancy-select2" name='pregnancy-select'/> */}
                                                    <input type="radio" id="pregnancy-select2" name='prgncPsblAt' value={'0'} checked={mediHlthInfo.prgncPsblAt === '0'} onChange={(e) => handleChangeRadio(e.target)}/>
                                                    <label htmlFor="pregnancy-select2">
                                                        <span>없음</span>
                                                    </label>
                                                </div>
                                            </li>
                                            <li>
                                                <div className='radio-selectbox'>
                                                    {/* <input type="radio" id="pregnancy-select3" name='pregnancy-select'/> */}
                                                    <input type="radio" id="pregnancy-select3" name='prgncPsblAt' value={'2'} checked={mediHlthInfo.prgncPsblAt === '2'} onChange={(e) => handleChangeRadio(e.target)}/>
                                                    <label htmlFor="pregnancy-select3">
                                                        <span>현재 임신중입니다</span>
                                                    </label>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            ) : null }

                            <div className="bottom-fixed-box">
                                <div className="inner-box">
                                    <div className='btn-layout' data-btn-num="2">
                                        <button className="btn" data-btn-type="outline-main" data-btn-size="lg" onClick={onClickPrev}>
                                            <span>이전</span>
                                        </button>
                                        <button className="btn" data-btn-type="fill-main" data-btn-size="lg" onClick={onClickNext} disabled={isNextBtnDisabled}>
                                            <span>다음</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* 마지막 로딩 화면 */}
                    {step === 'last' && (
                        <div className={style['last-loading-box']}>
                            <div className='animation-3'>
                                <p>
                                    <b>{user.usrNm}</b>님의 의료 정보를 <br />
                                    보기 편하게 요약하고 있어요.
                                </p>
                                <strong>잠시만 기다려주세요!</strong>
                                <div className={style['img-box']}>
                                    <img src={imgLastLoading} alt="" />
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                <Modal isOpen={saveCompleteOpen} setIsOpen={handleClickSaveCompleteBtn}>
                    <div className='modal-box' data-type="b">
                        <div className='modal-top-box'>
                            <div className='sub-box'>
                                <span>{user.usrNm}님의 의료 정보 모으기가 완료되었어요!</span>
                            </div>
                        </div>
                        <div className="modal-bottom-box">
                            <div className='btn-layout'>
                                <button className="btn" data-btn-type="fill-main" data-btn-size="lg" onClick={handleClickSaveCompleteBtn}>
                                    <span>확인</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>

                <Modal isOpen={cancelDataCollect} setIsOpen={setCancelDataCollect}>
                    <div className='modal-box' data-type="a">
                        <div className='modal-top-box'>
                            <div className='title-box'>
                                <p> 내 의료 정보 모으기를 그만하시겠어요?</p>
                                <p> 작성 중이던 내용은 모두 사라집니다. </p>
                            </div>
                            {/* <div className='sub-box'>
                                <span>주요 진단, 주요 수술력/처치력, 주요 약물력,</span>
                                <span>주요 검사 결과, 주치의 정보</span>
                            </div> */}
                        </div>

                        <div className="modal-bottom-box">
                            <div className='btn-layout'>
                                <button className="btn" data-btn-type="outline-main" data-btn-size="md" onClick={() => handleClickCancelBtn('no')}>
                                    <span>아니오</span>
                                </button>
                                <button className="btn" data-btn-type="fill-main" data-btn-size="md" onClick={() => handleClickCancelBtn('yes')}>
                                    <span>네</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
            {toast && (
                <ToastPopup
                    setToast={setToast}
                    message={toastMessage}
                    position="center"
                    opacity="90"
                />
            )}
        </>
    );
};

export default MyDataCollect;
